module.exports = __webpack_public_path__ + "static/media/M11ws.7084863b.pdf";